import { Component, AfterViewInit, OnInit, ChangeDetectorRef,  Renderer } from '@angular/core';

import {Title } from '@angular/platform-browser';

import { TdLoadingService, TdMediaService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';


@Component({
  selector: 'storage-stockcontrol',
  providers: [StorageService],
  templateUrl: './stockcontrol.component.html',
  styleUrls: ['./stockcontrol.component.scss']
})
export class StockcontrolComponent implements AfterViewInit, OnInit {

  parcelCode: string;
  scannedValue: string = null;
  
  storages: any[] = [];
  checkStorages: any[] = [];
  private storage: any = null;
  status: string = null;
  reference: string = null;

  private container: any = null;
  containerName: string;
  loadedContainer: boolean = false;  

  filterTitle: string;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    public renderer: Renderer) {
  }

  //@ViewChild('ft01') infocus: ElementRef;

  ngOnInit(): void {
    this._titleService.setTitle('Stock Control');
    this.load();
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('stockcontrol.list');
      this.loadFilter('Stock Control');    
    } catch (error) {

    } finally {
      this._loadingService.resolve('stockcontrol.list');
    }
  }

  async loadContainer(containerName: string): Promise<void> {
    try {
      //validate container: it must exist
      this.container = await this._storageService.getContainer(containerName).toPromise();
      this.containerName = this.container.name;
      this.loadedContainer = true;
      // load list of all parcels
      this.storages = await this._storageService.getContainerNameParcels(containerName).toPromise();
      for (let element of this.storages) { // add parcels to check list
        this.checkStorages.push(element); 
      }
    } catch (error) {
      //container does not exist
      this.loadedContainer = false;
    } finally {
    }
  }

  isContainerLoaded() {
    return this.loadedContainer;
  }

  async loadValue(value: string)   {
    try {
        this.parcelCode = value;
        // get parcel
        await this.getParcel(value);
        if (this.storage) {
          // check if parcel is in the list
          for (let i = this.checkStorages.length - 1; i >= 0; i--) {
              if (this.checkStorages[i].reference == this.storage.reference) {
                  this.checkStorages.splice(i, 1);
                  this.status = 'OK';
                  break;
              }
              this.status = 'wrongContainer';
          }
        } else {
          this.status = 'NoData';
        }
        this.scannedValue = null;
    } catch (error) {
        this.status = 'NoData';
        this.storage = null;
        this.scannedValue = null;
        console.log('Cannot get loadValue!');
    } finally {
    }
  }


  async getParcel(reference: string): Promise<void> {
    try{
          this.storages = await this._storageService.getParcel(reference).toPromise();
          this.storage = this.storages[0]; // for normal ch einlagern we assume we only get one
    } catch (error) {
        console.log('Cannot get parcel!');
        this.storage = null;
        this.scannedValue = null;
        this.status = 'NoData';
    } finally {
    }
  }


  getStatus() {
    return this.status;
  }

  keytab(event, from: string, to: string){
    if (from == 'containerName') {
      this.loadContainer(this.containerName);
    } else if (from == 'scannedValue') {
      this.loadValue(this.scannedValue);
    }

    let path = event.composedPath();
    let element = path[5]; // naviagte to md-card-content
    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (element.children[j].innerText == to) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }

  private async removeStorage(storage:any) {
    await this._storageService.updateStorageByBusinesskey(storage, 'TAKE_OUT_WAREHOUSE', storage.reference).toPromise();
    for (let i = this.checkStorages.length - 1; i >= 0; i--) {
      if (this.checkStorages[i].reference == storage.reference) {
        this.checkStorages.splice(i, 1);
      }
    }
  }

  goBack(): void {
    this.clearForm();
    this.container = null;
    this.containerName = null;
    this.checkStorages = [];
    this.loadedContainer = false;
    this._router.navigate(['/storage/control']);
  }

  clearForm() {
    this.parcelCode = '';
    this.storage = null;
    this.status = null;
    this.reference = null;
    this.load();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/storage/form/stockcontrol.component.ts